import request from '@/utils/request'

export function init () {
  return request({
    method: 'get',
    params: {
      do: 'init'
    }
  })
}
